import type { PopulationData } from '../../demographicsService'

export const POPULATION_PYRAMID_AGE_GROUPS = [
  '0-4',
  '5-9',
  '10-14',
  '15-19',
  '20-24',
  '25-29',
  '30-34',
  '35-39',
  '40-44',
  '45-49',
  '50-54',
  '55-59',
  '60-64',
  '65-69',
  '70-74',
  '75-79',
  '80-84',
  '85-89',
  '90+',
] as const

const MALE_FIELDS = [
  'men_population_0_4',
  'men_population_5_9',
  'men_population_10_14',
  'men_population_15_19',
  'men_population_20_24',
  'men_population_25_29',
  'men_population_30_34',
  'men_population_35_39',
  'men_population_40_44',
  'men_population_45_49',
  'men_population_50_54',
  'men_population_55_59',
  'men_population_60_64',
  'men_population_65_69',
  'men_population_70_74',
  'men_population_75_79',
  'men_population_80_84',
  'men_population_85_89',
  'men_population_90_plus',
] as const satisfies ReadonlyArray<keyof PopulationData>

const FEMALE_FIELDS = [
  'women_population_0_4',
  'women_population_5_9',
  'women_population_10_14',
  'women_population_15_19',
  'women_population_20_24',
  'women_population_25_29',
  'women_population_30_34',
  'women_population_35_39',
  'women_population_40_44',
  'women_population_45_49',
  'women_population_50_54',
  'women_population_55_59',
  'women_population_60_64',
  'women_population_65_69',
  'women_population_70_74',
  'women_population_75_79',
  'women_population_80_84',
  'women_population_85_89',
  'women_population_90_plus',
] as const satisfies ReadonlyArray<keyof PopulationData>

export interface PopulationPyramidSeriesData {
  ageGroups: string[]
  maleData: number[]
  femaleData: number[]
}

export const getPopulationPyramidSeriesData = (
  data: Pick<
    PopulationData,
    (typeof MALE_FIELDS)[number] | (typeof FEMALE_FIELDS)[number]
  >
): PopulationPyramidSeriesData => ({
  ageGroups: [...POPULATION_PYRAMID_AGE_GROUPS],
  maleData: MALE_FIELDS.map((field) => data[field] || 0),
  femaleData: FEMALE_FIELDS.map((field) => data[field] || 0),
})

export interface PopulationPyramidBarLayout {
  barGap: string
  barWidth: string
}

export const getPopulationPyramidBarLayout =
  (): PopulationPyramidBarLayout => ({
    barWidth: '80%',
    barGap: '-100%',
  })
